import { useAuth } from 'contexts/AuthProvider';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const Cart = () => {
    const { isAuthenticated, authenticating } = useAuth();
    const [redirect, setRedirect] = useState('');
    useEffect(() => {
        async function auth() {
            if (!authenticating && !isAuthenticated()) {
                setRedirect('/order/login');
            }
        };
        auth();
    }, [authenticating]);

    if(authenticating) return <></>;
    return redirect ? <Navigate to={redirect} /> : <><h1>This is cart!</h1></>;
}
export default Cart;